import { Countdown } from "./Countdown";
import { useContent } from "../context/ContentContext";

export const Hero = () => {
  const { content } = useContent();
  const scrollToRsvp = () => {
    document.getElementById("rsvp")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="hero"
      className="relative min-h-screen w-full flex items-center justify-center text-center overflow-hidden bg-sage-900"
    >
      {/* Use real <img> for reliable mobile rendering (bg-image has iOS quirks) */}
      {content.hero_image && (
        <img
          src={content.hero_image}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover"
          draggable={false}
        />
      )}
      <div className="absolute inset-0 hero-overlay" />
      <div className="absolute inset-0 grain pointer-events-none" />

      <div className="relative z-10 container mx-auto px-6 py-24 animate-fade-up hero-text-shadow">
        <p
          data-testid="hero-eyebrow"
          className="text-white/90 uppercase tracking-[0.4em] text-xs sm:text-sm mb-8"
        >
          {content.hero_eyebrow}
        </p>

        <h1
          data-testid="hero-names"
          className="font-script text-white text-6xl sm:text-7xl lg:text-[9rem] leading-none mb-4"
        >
          {content.hero_names}
        </h1>

        <div className="flex items-center justify-center gap-4 my-8">
          <span className="h-px w-16 bg-white/60" />
          <span className="text-white/95 text-sm uppercase tracking-[0.3em]">
            {content.hero_tagline}
          </span>
          <span className="h-px w-16 bg-white/60" />
        </div>

        <p
          data-testid="hero-subtitle"
          className="text-white font-serif italic text-xl sm:text-2xl mb-16 max-w-xl mx-auto"
        >
          {content.hero_subtitle}
        </p>

        <div className="mb-14">
          <Countdown />
        </div>

        <button
          data-testid="hero-rsvp-button"
          onClick={scrollToRsvp}
          className="inline-flex items-center gap-2 rounded-full bg-sage-900/40 hover:bg-sage-900/55 backdrop-blur border border-white/50 text-white px-8 py-4 text-sm uppercase tracking-[0.25em] transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
        >
          {content.hero_cta}
        </button>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/80 text-xs tracking-[0.3em] uppercase animate-float hero-text-shadow">
        ↓ Scroll
      </div>
    </section>
  );
};

export default Hero;
